import { ApiMethod } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api/useRestMutation';
import { QueryMissionControlUserPreferencesResponse } from './useQueryMissionControlUserPreferences';

export const UPDATE_GOAL_VISIBILITY_API_URL = '/i/missionControl/updateGoalVisibility';

export type UpdateGoalVisibilityMutationResponse = QueryMissionControlUserPreferencesResponse;
export type UpdateGoalVisibilityMutationBody = {
  goalId: string;
  visibleToCurrentUser: boolean;
};

export const useUpdateGoalVisibilityMutation = (
  options?: UseRestMutationOptions<UpdateGoalVisibilityMutationResponse>,
) => {
  return useRestMutation<UpdateGoalVisibilityMutationResponse, UpdateGoalVisibilityMutationBody>(
    UPDATE_GOAL_VISIBILITY_API_URL,
    ApiMethod.post,
    options,
  );
};
